export default __webpack_public_path__ + "static/media/calendar.68d3465b.svg";